<template>
  <power-bi code="eyJrIjoiMGJmNjA3OTAtM2JjNS00YmJiLTgzZDMtYmI0OTk1MzM2NTM4IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
